import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n';
import './index.css';
import './styles/globals.css';
import './styles/layout-fallback.css';
import './styles/visual-refresh.css';
import './styles/tables.css';

import { installSessionExpiryHandler } from './utils/sessionExpiry';

import { initializeMobileSession } from './utils/mobileServices';

installSessionExpiryHandler();

initializeMobileSession().finally(() => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(<React.StrictMode><App /></React.StrictMode>);
});
